import { NgModule } from '@angular/core';
import { RdfAngularCoreComponent } from './rdf-angular-core.component';



@NgModule({
  declarations: [
    RdfAngularCoreComponent
  ],
  imports: [
  ],
  exports: [
    RdfAngularCoreComponent
  ]
})
export class RdfAngularCoreModule { }
